import { render, staticRenderFns } from "./AspectRatioIcon.vue?vue&type=template&id=f08ed0de&scoped=true"
import script from "./AspectRatioIcon.vue?vue&type=script&lang=js"
export * from "./AspectRatioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08ed0de",
  null
  
)

export default component.exports